exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* App Colors\n------------------------------------------------------------ */\nh1 {\n  color: #0076ff; }\n\n.page-container {\n  display: block;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0; }\n\n.modal-screen {\n  display: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 999999;\n  background: rgba(0, 100, 100, 0.8); }\n  .modal-screen.show {\n    display: block; }\n  .modal-screen .message-text {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    color: #ffffff;\n    font-size: 48px;\n    font-weight: 700;\n    transform: translate(-50%, -50%); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/main-page/main-page.scss
// module id = ../../../../../src/app/admin-area/containers/main-page/main-page.scss
// module chunks = main